import { TranslatedString } from 'lemunzo-api';

/**
 * Enum representing supported types of form elements.
 */
export enum ElementType {
    Input,
    Textarea,
    Checkbox,
    Radio,
    Select,
    LanguageSelect,
    CountrySelect,
}

export enum AddedElementVisibility {
    /**
     * Visible only for admins in admin portal views
     */
    AdminOnly = 0,
    /**
     * Hidden during initial registration; editable after registration
     */
    EditOnly = 1,
    /**
     * Visible in all stages and editable whenever edit mode is enabled
     */
    AlwaysEditable = 2,
    /**
     * Editable during initial registration, then read-only for clients
     */
    RegistrationOnly = 3,
}

/**
 * Represents a model for an added form element.
 * This class is used to encapsulate information about a general form element,
 * including its type, associated value, and whether it is required.
 */
export class AddedElementModel {
    key: string;
    type: ElementType;
    name: TranslatedString;
    label: TranslatedString;
    required: boolean;
    visible: AddedElementVisibility;
    deletable: boolean;
    defaultElement: boolean;

    constructor(
        type: ElementType,
        name: TranslatedString,
        label: TranslatedString,
        required: boolean = false,
        visible: AddedElementVisibility = AddedElementVisibility.AlwaysEditable,
        deletable: boolean = true,
        defaultElement: boolean = false
    ) {
        this.key = crypto.randomUUID();
        this.type = type;
        this.name = name;
        this.label = label;
        this.required = required;
        this.visible = visible;
        this.deletable = deletable;
        this.defaultElement = defaultElement;
    }
}
